import { List } from "@mantine/core";
import { useTranslation } from "react-i18next";

export const FlexFeatures = () => {
    const { t } = useTranslation(["common"]);

    return (
        <List>
            <List.Item>{t("upgrade.flex.scan-limit")}</List.Item>
            <List.Item>{t("upgrade.flex.word-limit")}</List.Item>
            <List.Item>{t("upgrade.flex.ai-scan")}</List.Item>
            <List.Item>{t("upgrade.flex.follow-up-questions")}</List.Item>
        </List>
    );
};
